export type SocialPlatform =
  | "instagram" | "tiktok" | "youtube" | "twitter" | "linkedin" | "facebook" | "threads";

export const SOCIAL_LABEL: Record<SocialPlatform, string> = {
  instagram: "Instagram",
  tiktok:    "TikTok",
  youtube:   "YouTube",
  twitter:   "X (Twitter)",
  linkedin:  "LinkedIn",
  facebook:  "Facebook",
  threads:   "Threads"
};

export const SOCIAL_ICON: Record<SocialPlatform, string> = {
  instagram: "◉",
  tiktok:    "♪",
  youtube:   "▶",
  twitter:   "𝕏",
  linkedin:  "in",
  facebook:  "f",
  threads:   "@"
};

export const SOCIAL_COLOR: Record<SocialPlatform, string> = {
  instagram: "#E1306C",
  tiktok:    "#000000",
  youtube:   "#FF0000",
  twitter:   "#000000",
  linkedin:  "#0A66C2",
  facebook:  "#1877F2",
  threads:   "#000000"
};

/** Melhores janelas de postagem padrão (heurística — pode ser sobrescrito por análise). */
export const DEFAULT_BEST_TIMES: Record<SocialPlatform, string[]> = {
  instagram: ["seg 12h", "ter 19h", "qua 12h", "qui 19h-21h", "sex 12h", "sab 11h", "dom 20h"],
  tiktok:    ["ter 09h", "ter 19h", "qua 12h", "qui 19h", "sex 12h", "sex 21h", "sab 19h"],
  youtube:   ["qui 14h-16h", "sex 14h-16h", "sab 09h-11h", "dom 09h-11h"],
  twitter:   ["seg-sex 09h", "seg-sex 12h", "seg-sex 17h"],
  linkedin:  ["ter 08h", "qua 08h", "qui 08h", "ter 12h", "qua 17h"],
  facebook:  ["qua 11h-13h", "qui 13h-16h", "sex 13h-15h"],
  threads:   ["seg-sex 10h", "seg-sex 19h", "sab-dom 11h"]
};
